import { supabase } from "@/integrations/supabase/client";
import { saveCondominium, saveUnits, saveProfiles } from "./repos";

// Função para sincronizar as configurações do Condomínio
export const syncCondominium = async (condominiumId: string): Promise<boolean> => {
  try {
    if (!navigator.onLine) return false;

    console.log("[Sync] Sincronizando condomínio...", condominiumId);
    const { data, error } = await supabase
      .from("condominiums")
      .select("*")
      .eq("id", condominiumId)
      .single();

    if (error) throw error;
    if (data) {
      await saveCondominium(data);
      console.log("[Sync] Condomínio sincronizado com sucesso localmente.");
      return true;
    }
    return false;
  } catch (error) {
    console.error("[Sync] Erro ao sincronizar condomínio:", error);
    return false;
  }
};

// Função para sincronizar as Unidades (Apartamentos/Blocos)
export const syncUnits = async (condominiumId: string): Promise<boolean> => {
  try {
    if (!navigator.onLine) return false;

    console.log("[Sync] Sincronizando unidades...", condominiumId);
    const { data, error } = await supabase
      .from("units")
      .select("*")
      .eq("condominium_id", condominiumId);

    if (error) throw error;
    if (data && data.length > 0) {
      await saveUnits(data);
      console.log(`[Sync] ${data.length} unidades sincronizadas localmente.`);
      return true;
    }
    return false;
  } catch (error) {
    console.error("[Sync] Erro ao sincronizar unidades:", error);
    return false;
  }
};

// Função para sincronizar Perfis (Moradores, Porteiros, Síndicos)
export const syncProfiles = async (condominiumId: string): Promise<boolean> => {
  try {
    if (!navigator.onLine) return false;

    console.log("[Sync] Sincronizando perfis...", condominiumId);
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("condominium_id", condominiumId);

    if (error) throw error;
    if (data && data.length > 0) {
      await saveProfiles(data);
      console.log(`[Sync] ${data.length} perfis sincronizados localmente.`);
      return true;
    }
    return false;
  } catch (error) {
    console.error("[Sync] Erro ao sincronizar perfis:", error);
    return false;
  }
};

// Sincronização completa de dados cadastrais
export const syncAllData = async (condominiumId: string): Promise<boolean> => {
  if (!condominiumId) return false;
  
  console.log("[Sync] Iniciando sincronização completa...");
  const condoOk = await syncCondominium(condominiumId);
  const unitsOk = await syncUnits(condominiumId);
  const profilesOk = await syncProfiles(condominiumId);
  
  const success = condoOk && unitsOk && profilesOk;
  if (success) {
    console.log("[Sync] Sincronização completa finalizada com SUCESSO.");
  } else {
    console.log("[Sync] Sincronização completa finalizada com erros parciais ou offline.");
  }
  return success;
};
